<template>
  <div class="ma-4">
    <ClientNav />
    <v-row dense>
      <v-col cols="12" lg="3" xl="2">
        <ClientSide />
      </v-col>
      <v-col cols="12" lg="9" xl="10">
        <FormTable :title="title" />
      </v-col>
    </v-row>
  </div>
  </template>

<script>
import ClientNav from "@/components/ClientNav";
import ClientSide from "@/components/ClientSide";
import FormTable from "./FormTable";

export default {
  components: {
    ClientNav,
    ClientSide,
    FormTable,
  },
  data: () => ({
    title: "Weight Tracking",
  }),
};
</script>

